import { useState, useEffect } from 'react';
import { db, auth } from './firebase';
import { signInWithEmailAndPassword, signOut, onAuthStateChanged } from 'firebase/auth';
import { collection, addDoc, getDocs, deleteDoc, doc, updateDoc } from 'firebase/firestore';
import GerenciarUsuarios from './GerenciarUsuarios';
import ListarUsuarios from './ListarUsuarios';
import './estilo.css';

export default function SistemaGestao() {
  const [usuario, setUsuario] = useState(null);
  const [email, setEmail] = useState('');
  const [senha, setSenha] = useState('');
  const [nome, setNome] = useState('');
  const [descricao, setDescricao] = useState('');
  const [responsavel, setResponsavel] = useState('');
  const [novoPasso, setNovoPasso] = useState('');
  const [sistemas, setSistemas] = useState([]);
  const [passos, setPassos] = useState([]);
  const [editandoId, setEditandoId] = useState(null);
  const [pesquisa, setPesquisa] = useState('');

  useEffect(() => {
    onAuthStateChanged(auth, user => {
      setUsuario(user);
      if (user) carregarSistemas();
    });
  }, []);

  async function login() {
    try {
      await signInWithEmailAndPassword(auth, email, senha);
    } catch {
      alert('Email ou senha incorretos.');
    }
  }

  async function logout() {
    await signOut(auth);
  }

  async function carregarSistemas() {
    const querySnapshot = await getDocs(collection(db, 'sistemas'));
    const lista = querySnapshot.docs.map(docRef => ({
      ...docRef.data(),
      id: docRef.id
    }));
    setSistemas(lista);
  }

  async function criarOuEditarSistema() {
    if (!nome.trim() || !responsavel.trim()) {
      alert('Preencha nome e responsável.');
      return;
    }

    const sistemaData = {
      nome,
      descricao,
      passos,
      responsavel,
      dataCriacao: new Date().toLocaleString(),
      status: 'Não iniciado'
    };

    if (editandoId) {
      await updateDoc(doc(db, 'sistemas', editandoId), sistemaData);
      setEditandoId(null);
    } else {
      await addDoc(collection(db, 'sistemas'), sistemaData);
    }

    setNome('');
    setDescricao('');
    setResponsavel('');
    setPassos([]);
    carregarSistemas();
  }

  async function excluirSistema(id) {
    await deleteDoc(doc(db, 'sistemas', id));
    carregarSistemas();
  }

  const sistemasFiltrados = sistemas.filter(s =>
    s.nome.toLowerCase().includes(pesquisa.toLowerCase()) ||
    s.descricao.toLowerCase().includes(pesquisa.toLowerCase())
  );

  return (
    <div className="sistema-container">
      <header className="header">
        <span>{usuario ? usuario.email : 'Não autenticado'}</span>
        {usuario && <button className="btn btn-logout" onClick={logout}>Logout</button>}
      </header>

      {!usuario && (
        <div className="login-card">
          <input
            className="input"
            placeholder="Email"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          <input
            type="password"
            className="input"
            placeholder="Senha"
            value={senha}
            onChange={e => setSenha(e.target.value)}
          />
          <button className="btn btn-primary" onClick={login}>Entrar</button>
        </div>
      )}

      {usuario && (
        <>
          <div className="card">
            <h2>Criar / Editar Sistema</h2>
            <input
              className="input"
              placeholder="Nome do Sistema"
              value={nome}
              onChange={e => setNome(e.target.value)}
            />
            <textarea
              className="input"
              placeholder="Descrição"
              value={descricao}
              onChange={e => setDescricao(e.target.value)}
            />
            <input
              className="input"
              placeholder="Responsável"
              value={responsavel}
              onChange={e => setResponsavel(e.target.value)}
            />
            <div className="passos">
              <input
                className="input"
                placeholder="Novo Passo"
                value={novoPasso}
                onChange={e => setNovoPasso(e.target.value)}
              />
              <button
                className="btn btn-secondary"
                onClick={() => {
                  if (novoPasso) {
                    setPassos([...passos, novoPasso]);
                    setNovoPasso('');
                  }
                }}
              >
                Adicionar Passo
              </button>
              <ul className="passos-lista">
                {passos.map((p, idx) => (
                  <li key={idx}>
                    {idx + 1}. {p}
                    <button
                      className="btn-remover"
                      onClick={() => {
                        const novosPassos = [...passos];
                        novosPassos.splice(idx, 1);
                        setPassos(novosPassos);
                      }}
                    >
                      Remover
                    </button>
                  </li>
                ))}
              </ul>
            </div>
            <button
              className="btn btn-primary"
              onClick={criarOuEditarSistema}
            >
              {editandoId ? 'Salvar Edição' : 'Salvar Sistema'}
            </button>
          </div>

          <div className="card">
            <h2>Sistemas</h2>
            <input
              className="input"
              placeholder="Pesquisar..."
              value={pesquisa}
              onChange={e => setPesquisa(e.target.value)}
            />
            {sistemasFiltrados.map((sistema) => (
              <div key={sistema.id} className="sistema-item">
                <h3>{sistema.nome}</h3>
                <p>{sistema.descricao}</p>
                <p><b>Responsável:</b> {sistema.responsavel}</p>
                <div className="acoes">
                  <button className="btn btn-edit" onClick={() => {
                    setNome(sistema.nome);
                    setDescricao(sistema.descricao);
                    setResponsavel(sistema.responsavel);
                    setPassos(sistema.passos || []);
                    setEditandoId(sistema.id);
                  }}>
                    Editar
                  </button>
                  <button className="btn btn-delete" onClick={() => excluirSistema(sistema.id)}>
                    Excluir
                  </button>
                </div>
              </div>
            ))}
          </div>

          {usuario.email === 'thiago@capilaressencia.com.br' && (
            <>
              <GerenciarUsuarios />
              <ListarUsuarios usuario={usuario} />
            </>
          )}
        </>
      )}
    </div>
  );
}